import { z } from 'zod/v4';
import { InteractionType } from '../../interactions/index.js';
import { Lang } from '../../lang/Lang.js';
import { ToolCategory, ToolName, ToolPolicy, ToolWeight } from '../types.js';
const inputSchema = z.object({
    templateId: z
        .uuid()
        .describe('The template to fetch. Obtain via search_templates — do not invent ids.'),
});
const outputSchema = z.object({
    templateId: z.uuid(),
    name: z.string(),
    type: z.enum(InteractionType),
    language: z.enum(Lang).nullable(),
    subject: z.string().nullable(),
    body: z.string(),
    html: z.string().nullable(),
    tags: z.array(z.string()),
    availableMentions: z.array(z.string()),
});
export const getTemplateTool = {
    name: ToolName.GetTemplate,
    category: ToolCategory.Templates,
    weight: ToolWeight.Light,
    version: 1,
    defaultPolicy: ToolPolicy.AutoRun,
    llmDescription: "Read a template's full body and metadata. Preserve {{mention}} placeholders verbatim so they hydrate from live case state. For CLIENT NOTE creditor-message templates, use the html field as the proposed HTML body and pass templateId. For other channels, follow the matching heavy tool's body guidance.",
    inputSchema,
    outputSchema,
};
//# sourceMappingURL=get-template.js.map